import {
  REGEX_PATTERN_EMAIL,
  REGEX_PATTERN_WHITESPACE,
  PASSWORD_POLICY,
  REGEX_PATTERN_NUMBER,
} from '../utils/global';

import lang from '../assets/i18n/en.json';

export const emailValidation = (email, errors, setError) => {
  const checkEmail = email.toLowerCase();
  const regex = REGEX_PATTERN_EMAIL();
  const whiteSpace = REGEX_PATTERN_WHITESPACE();
  let checkWorkEmail = !(
    checkEmail.includes('yahoo') ||
    checkEmail.includes('outlook') ||
    checkEmail.includes('hotmail') ||
    checkEmail.includes('aol')
  );
  if (
    regex.test(checkEmail) &&
    checkEmail.match(whiteSpace) &&
    checkWorkEmail &&
    checkEmail.length < 500
  ) {
    setError((errors) => ({
      ...errors,
      email: false,
      emailError: lang?.PAGE?.AUTH?.SIGNIN?.USERNAME?.VALIDATION_TEXT,
    }));
  } else if (checkEmail.length > 500) {
    setError((errors) => ({
      ...errors,
      email: true,
      emailError: lang?.PAGE?.AUTH?.SIGNIN?.USERNAME?.MAX_LENGTH,
    }));
  } else {
    setError((errors) => ({
      ...errors,
      email: true,
      emailError: lang?.PAGE?.AUTH?.SIGNIN?.USERNAME?.VALIDATION_TEXT,
    }));
  }
};

export const passwordValidation = (password, errors, setError) => {
  let userPassword = PASSWORD_POLICY(password);
  if (userPassword.errorStatus) {
    setError((errors) => ({
      ...errors,
      password: true,
      passwordError: lang?.PAGE?.AUTH?.SIGNIN?.PASSWORD.VALIDATION_TEXT,
    }));
  } else {
    setError((errors) => ({
      ...errors,
      password: false,
      passwordError: '',
    }));
  }
};

export const nameValidation = (name, value, setError) => {
  let errorStatus = false;
  let errorMessage = '';
  if (value.trim() === '') {
    errorStatus = true;
    name === 'firstName'
      ? (errorMessage = lang.PAGE.AUTH.SIGNUP.FIRSTNAME.VALIDATION_ERROR)
      : (errorMessage = lang.PAGE.AUTH.SIGNUP.LASTNAME.VALIDATION_ERROR);
  } else if (!/^[A-Za-z ]+$/.test(value)) {
    errorStatus = true;
    name === 'firstName'
      ? (errorMessage = 'Please enter valid first name')
      : (errorMessage = 'Please enter valid last name');
  } else if (value.length > 50) {
    errorStatus = true;
    name === 'firstName'
      ? (errorMessage = lang.PAGE.AUTH.SIGNUP.FIRSTNAME.MAX_LENGTH)
      : (errorMessage = lang.PAGE.AUTH.SIGNUP.LASTNAME.MAX_LENGTH);
  }

  switch (name) {
    case 'firstName':
      setError((errors) => ({
        ...errors,
        firstName: errorStatus,
        firstNameError: errorMessage,
      }));
      break;
    case 'lastName':
      setError((errors) => ({
        ...errors,
        lastName: errorStatus,
        lastNameError: errorMessage,
      }));
      break;

    default: {
    }
  }
};

export const validateNumber = (mobileno, setError) => {
  const regex = REGEX_PATTERN_NUMBER();
  if (regex.test(mobileno)) {
    setError((errors) => ({
      ...errors,
      mobileno: false,
      mobilenoError: '',
    }));
  } else {
    setError((errors) => ({
      ...errors,
      mobileno: true,
      mobilenoError: 'Enter valid phone number.',
    }));
  }
};

export const comparePasswords = (
  fieldName,
  value,
  userDataPasswordValue,
  setError,
) => {
  switch (fieldName) {
    case 'password':
      let res = PASSWORD_POLICY(value);
      let confirmpasswordValue = userDataPasswordValue;
      if (res.errorStatus === false && confirmpasswordValue !== value) {
        setError((errors) => ({
          ...errors,
          confirmPassword: true,
          confirmPasswordError: 'Password should match.',
        }));
      } else {
        setError((errors) => ({
          ...errors,
          confirmPassword: false,
          confirmPasswordError: '',
        }));
      }
      setError((errors) => ({
        ...errors,
        password: res.errorStatus,
        passwordError: res.errorMessage,
      }));

      break;
    case 'confirmpassword':
      let cpres = { errorStatus: false, errorMessage: '' };
      let passwordValue = userDataPasswordValue;
      if (cpres.errorStatus === false && passwordValue !== value) {
        cpres.errorStatus = true;
        cpres.errorMessage = 'Password should match.';
      }
      setError((errors) => ({
        ...errors,
        confirmPassword: cpres.errorStatus,
        confirmPasswordError: cpres.errorMessage,
      }));
      break;

      default: {
      }
  }
};
